"use client";

import React from "react";
import { motion } from "framer-motion";
import { useTranslations } from "next-intl";
import Link from "next/link";

export default function PartnerWithUsSection() {
  const t = useTranslations("enterprise");
  return (
    <section className="bg-[url('/images/backgrounds/bg-partner-with-us.png')] bg-cover py-[120px] max-lg:px-10 max-sm:px-4">
      <motion.div
        initial={{ opacity: 0, translateY: 40 }}
        whileInView={{ opacity: 1, translateY: 0 }}
        transition={{ duration: 1, ease: "easeOut" }}
        viewport={{ once: true }}
      >
        <div className="mx-auto w-full max-w-[874px] rounded-3xl border-[2px] border-white bg-[#F3F8FF61]/[38%] py-16 text-center backdrop-blur-sm">
          <h3 className="max-sm: text-[48px]/[56px] font-normal tracking-[-1px] text-black max-sm:text-2xl">
            <span className="text-[#06f]">{t("partner")}</span> {t("with-us")}
          </h3>
          <p className="mb-10 mt-5 text-base font-light text-[#646464] max-sm:text-sm">
            {t("position-your-portfolio-secure-your-ai-future")}
          </p>
          <Link
            href={"mailto:support@hyra.network"}
            className="mx-auto h-fit w-fit"
          >
            <button className="rounded-xl bg-[#06f] px-[45px] py-4 text-lg/[18px] uppercase text-white">
              {t("contact-us")}
            </button>
          </Link>
        </div>
      </motion.div>
    </section>
  );
}
